import { FILTER } from '../../../constants/actionTypes';
import { dispatchActionAndFetchData, dispatchAction } from './data';

const clearFiltersAndApplySingle = action => dispatch => {
  dispatch({ type: FILTER.CLEAR });
  return dispatch(action);
};

export const clearFilter = () =>
  dispatchActionAndFetchData({
    type: FILTER.CLEAR,
  });

export const filterUpdateSort = (sortOn, sortType) =>
  dispatchActionAndFetchData({
    type: FILTER.SORT,
    sortOn,
    sortType,
  });

export const filterUpdateAll = filter =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.ALL,
    filter,
  });

export const filterUpdateTags = tags =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.TAGS,
    tags,
  });

export const filterUpdateQuery = query =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.QUERY,
    query,
  });

export const filterUpdateCreator = id =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.CREATOR,
    id,
  });

export const filterUpdateInstructor = instructor =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.INSTRUCTOR,
    instructor,
  });

export const filterUpdatePastOrUpcoming = pastOrUpcoming =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.PAST_OR_UPCOMING,
    pastOrUpcoming,
  });

export const filterUpdateContentType = contentType =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.CONTENT_TYPE,
    contentType,
  });

export const filterUpdatePage = page =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.PAGE,
    page,
  });

export const filterByTag = tags =>
  clearFiltersAndApplySingle(filterUpdateTags(tags));

export const filterUpdateDate = date =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.DATE,
    date,
  });

export const filterUpdateGroups = groups =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.GROUPS,
    groups,
  });

export const filterUpdateRole = roleId =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.ROLE,
    roleId,
  });

export const filterUpdateManager = manager =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.MANAGER,
    manager,
  });

export const filterUpdatePerPage = perPage =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.PER_PAGE,
    perPage,
  });

export const filterByGroup = group =>
  clearFiltersAndApplySingle(filterUpdateGroups([group]));

export const filterUpdateType = contentType =>
  clearFiltersAndApplySingle(
    dispatchActionAndFetchData({
      type: FILTER.UPDATE.TYPE,
      contentType,
    }),
  );

export const filterUpdateActiveGroup = group =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.ACTIVE_GROUP,
    group,
  });

export const filterUpdateMyOrganization = myOrganization =>
  dispatchAction({
    type: FILTER.UPDATE.MY_ORGANIZATION,
    myOrganization,
  });

export const filterUpdateEditing = editing =>
  dispatchAction({
    type: FILTER.UPDATE.EDITING,
    editing,
  });

export const filterUpdateWorkspace = id =>
  dispatchActionAndFetchData({
    type: FILTER.UPDATE.WORKSPACE,
    id,
  });
